import lazyLoading from "./lazyLoading";

export default {
  name: "mikrobiologija",
  path: "/mikrobiologija",
  component: lazyLoading("mikrobiologija/Mikrobiologija"),
  meta: {
    default: false,
    title: "Mikrobiologija",
    class: "warning",
    show: true,
    iconClass: "fa fa-bug",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/mikrobiologija.js